import React from "react";
import { useNavigate } from "react-router-dom";

const QuickActions = ({ onOpenAIModal }) => {
  const navigate = useNavigate();

  const actions = [
    {
      title: "Create Survey",
      description: "Start a new survey project",
      icon: (
        <svg
          className="w-5 h-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M12 4v16m8-8H4"
          />
        </svg>
      ),
      iconBg: "bg-blue-50",
      iconColor: "text-[#0226BE]",
      onClick: () => navigate("/surveys", { state: { openCreateModal: true } }),
    },
    {
      title: "View Invoices",
      description: "Check billing status",
      icon: (
        <svg
          className="w-5 h-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
          />
        </svg>
      ),
      iconBg: "bg-green-50",
      iconColor: "text-green-600",
      onClick: () => navigate("/invoice-billing"),
    },
    {
      title: "Manage Groups",
      description: "Organize survey groups",
      icon: (
        <svg
          className="w-5 h-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
          />
        </svg>
      ),
      iconBg: "bg-orange-50",
      iconColor: "text-orange-600",
      onClick: () => navigate("/survey-groups"),
    },
    {
      title: "Qualifications",
      description: "Manage question library",
      icon: (
        <svg
          className="w-5 h-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      ),
      iconBg: "bg-purple-50",
      iconColor: "text-purple-600",
      onClick: () => navigate("/qualification-library"),
    },
  ];

  return (
    <div className="bg-white border border-[#E0E0E0] rounded-xl overflow-hidden">
      <div className="px-6 py-4 border-b border-[#E0E0E0]">
        <h3 className="text-[#333] text-[16px] font-[500]">Quick Actions</h3>
        <p className="text-[13px] text-[#666] mt-0.5">
          Frequently used actions for quick access
        </p>
      </div>

      <div className="p-5">
        {/* AI Survey Creator - Clean Card */}
        <button
          onClick={onOpenAIModal}
          className="w-full group mb-4 p-4 bg-[#F8F9FF] hover:bg-[#F0F3FF] border border-[#E8EBFF] rounded-xl transition-all text-left flex items-center gap-4"
        >
          <div className="w-11 h-11 rounded-lg bg-[#0226BE] flex items-center justify-center flex-shrink-0">
            <svg className="w-5 h-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456z" />
            </svg>
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2">
              <h4 className="text-[14px] font-[500] text-[#333]">Create Survey with AI</h4>
              <span className="px-1.5 py-0.5 text-[10px] font-[600] bg-[#0226BE] text-white rounded">
                NEW
              </span>
            </div>
            <p className="text-[12px] text-[#666] mt-0.5">
              Paste your RFP and let AI configure everything automatically
            </p>
          </div>
          <svg className="w-5 h-5 text-[#999] group-hover:text-[#0226BE] group-hover:translate-x-0.5 transition-all flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 5l7 7-7 7" />
          </svg>
        </button>

        {/* Action Cards Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {actions.map((action, index) => (
            <button
              key={index}
              onClick={action.onClick}
              className="group p-4 bg-white border border-[#E0E0E0] hover:border-[#0226BE]/30 hover:shadow-sm rounded-xl transition-all text-left"
            >
              <div className={`w-10 h-10 ${action.iconBg} rounded-lg flex items-center justify-center mb-3`}>
                <span className={action.iconColor}>{action.icon}</span>
              </div>
              <h4 className="text-[13px] font-[500] text-[#333] group-hover:text-[#0226BE] transition-colors">
                {action.title}
              </h4>
              <p className="text-[11px] text-[#888] mt-0.5">{action.description}</p>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuickActions;
